import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import BoxIcon from '~/images/home_swag_packs_box.svg';
import HappyFaceIcon from '~/images/home_swag_packs_happy_face.svg';
import HeartIcon from '~/images/home_swag_packs_heart.svg';
import StarIcon from '~/images/home_swag_packs_star.svg';
import { baseImgUrl } from '~/utils/constants';

export default function SwagPacks() {
  const theme = useTheme();

  return (
    <Box position="relative">
      <Container sx={{ py: { xs: 6, md: 10 } }}>
        <Stack alignItems="center" mb={2}>
          <Typography variant="h4" mb={3} textAlign="center" width={{ xs: '100%', sm: '50%', md: '45%', lg: '32%' }}>
            Your Brand Package Your Vision Personified
          </Typography>

          <Typography variant="subtitle1" width={{ xs: '100%', sm: '80%', md: '50%' }} textAlign="center">
            At <strong>SwagCharm</strong>, we understand that your brand is the package deal. You deserve products that
            embody your passion and capture your Swag. That’s why we work diligently to curate exclusive,{' '}
            <strong>high-quality Swag brands for your team, school, or organization</strong>.
          </Typography>
        </Stack>

        <Stack alignItems="center" position="relative">
          <Stack position="relative">
            <Box
              position={{ xs: 'initial', lg: 'absolute' }}
              mt={{ xs: 9, lg: 0 }}
              mb={{ xs: 4, lg: 0 }}
              top={60}
              left={-121}
              width={{ xs: '100%', lg: 250 }}
              p="16px 22px"
              bgcolor="rgba(255, 255, 255, 0.7)"
              boxShadow="0px 4px 40px rgba(0, 0, 0, 0.1)"
              borderRadius="100px"
              sx={{
                backdropFilter: 'blur(40px)',
              }}
            >
              <Typography variant="subtitle1" textAlign="center" lineHeight="20px">
                Complete Swag <strong>customization and design</strong>
              </Typography>
            </Box>

            <Box
              position={{ xs: 'initial', lg: 'absolute' }}
              top={55}
              right={-149}
              width={{ xs: '100%', lg: 340 }}
              p="16px 22px"
              bgcolor="rgba(255, 255, 255, 0.7)"
              boxShadow="0px 4px 40px rgba(0, 0, 0, 0.1)"
              borderRadius="100px"
              sx={{
                backdropFilter: 'blur(40px)',
              }}
            >
              <Typography variant="subtitle1" textAlign="center" lineHeight="20px">
                <strong>Bespoke presentation</strong> selected by you for your sector and sphere of influence
              </Typography>
            </Box>

            <img
              src={`${baseImgUrl}swagcharm-factory-home.png`}
              srcSet={`${baseImgUrl}swagcharm-factory-home.png, ${baseImgUrl}swagcharm-factory-home-2x.png 2x, ${baseImgUrl}swagcharm-factory-home-3x.png 3x`}
              alt="hero home"
              width={600}
              height={600}
              style={{
                width: '100%',
                height: 'auto',
                minWidth: '100%',
                minHeight: '100%',
                maxHeight: '600px',
              }}
            />

            <Box
              position={{ xs: 'initial', lg: 'absolute' }}
              top={352}
              left={-252}
              mb={{ xs: 4, lg: 0 }}
              width={{ xs: '100%', lg: 345 }}
              p="16px 22px"
              bgcolor="rgba(255, 255, 255, 0.7)"
              boxShadow="0px 4px 40px rgba(0, 0, 0, 0.1)"
              borderRadius="100px"
              sx={{
                backdropFilter: 'blur(40px)',
              }}
            >
              <Typography variant="subtitle1" textAlign="center" lineHeight="20px">
                <strong>Dependable fulfillment</strong> to ensure your Swag arrives on time, every time
              </Typography>
            </Box>

            <Box
              position={{ xs: 'initial', lg: 'absolute' }}
              top={535}
              right={-146}
              width={{ xs: '100%', lg: 436 }}
              p="16px 22px"
              bgcolor="rgba(255, 255, 255, 0.7)"
              boxShadow="0px 4px 40px rgba(0, 0, 0, 0.1)"
              borderRadius="100px"
              sx={{
                backdropFilter: 'blur(40px)',
              }}
            >
              <Typography variant="subtitle1" textAlign="center" lineHeight="20px">
                <strong>Functional and flexible Swag</strong> delivery options from our crisp and clean Swag box to our
                minimalist tote bag, or even our functional swag backpack
              </Typography>
            </Box>
          </Stack>

          <Box
            position="absolute"
            top={{ xs: 146, md: 0 }}
            left={{ xs: '10%', md: 0 }}
            right={{ xs: '10%', md: 'auto' }}
            width={{ xs: 'auto', md: 430 }}
            height={{ xs: 600, md: 492 }}
          >
            <Box
              position="absolute"
              top={0}
              left={0}
              width="50%"
              height="50%"
              borderRadius="50%"
              bgcolor="secondary.main"
              zIndex={-1}
              sx={{ filter: 'blur(158.5px)', opacity: 0.45 }}
            ></Box>
            <Box
              position="absolute"
              bottom={0}
              right={0}
              width="50%"
              height="50%"
              borderRadius="50%"
              bgcolor="#009DC8"
              zIndex={-1}
              sx={{ filter: 'blur(158.5px)' }}
            ></Box>
          </Box>

          <Box
            position="absolute"
            top={{ xs: 1200, md: 0 }}
            left={{ xs: '10%', md: 454 }}
            right={{ xs: '10%', md: 'auto' }}
            width={{ xs: 'auto', md: 430 }}
            height={{ xs: 300, md: 492 }}
          >
            <Box
              position="absolute"
              top={0}
              left={0}
              width="50%"
              height="50%"
              borderRadius="50%"
              bgcolor="secondary.main"
              zIndex={-1}
              sx={{ filter: 'blur(158.5px)', opacity: 0.45 }}
            ></Box>
            <Box
              position="absolute"
              bottom={0}
              right={0}
              width="50%"
              height="50%"
              borderRadius="50%"
              bgcolor="#009DC8"
              zIndex={-1}
              sx={{ filter: 'blur(158.5px)' }}
            ></Box>
          </Box>
        </Stack>

        <Stack mt={12} mb={13} position="relative" alignItems="center">
          <Stack>
            <Typography variant="h4" mb={3} width={{ xs: '100%', sm: '50%', md: '38%' }}>
              You Deliver For Others Now It’s Our Turn To Deliver For You
            </Typography>

            <Typography variant="body1" width={{ xs: '100%', sm: '80%' }} mb={8}>
              We handle it all. With SwagCharm, you’ll enjoy:
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <Stack alignItems="center">
                  <Box p={2}>
                    <img src={HeartIcon} alt="Heart icon" width={64} height={64} />
                  </Box>
                  <Typography variant="h6" textAlign="center">
                    Top-tier design
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Stack alignItems="center">
                  <Box p={2}>
                    <img src={StarIcon} alt="Star icon" width={64} height={64} />
                  </Box>
                  <Typography variant="h6" textAlign="center">
                    High-quality production
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Stack alignItems="center">
                  <Box p={2}>
                    <img src={BoxIcon} alt="Box icon" width={64} height={64} />
                  </Box>
                  <Typography variant="h6" textAlign="center">
                    Safe storage that protects your Swag
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Stack alignItems="center">
                  <Box p={2}>
                    <img src={HappyFaceIcon} alt="HappyFace icon" width={64} height={64} />
                  </Box>
                  <Typography variant="h6" textAlign="center">
                    Captivating packaging as exciting as your brand
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Stack>

          <Box position="absolute" top={-69} width={816} height={639} display={{ xs: 'none', md: 'flex' }}>
            <Box
              position="absolute"
              bottom={0}
              left={0}
              width={315}
              height={315}
              borderRadius="50%"
              bgcolor="#FF68F9"
              zIndex={-1}
              sx={{ filter: 'blur(250px)', opacity: 0.89 }}
            ></Box>
            <Box
              position="absolute"
              top={0}
              right={0}
              width={555}
              height={555}
              borderRadius="50%"
              bgcolor="#009DC8"
              zIndex={-1}
              sx={{ filter: 'blur(250px)', opacity: 0.3 }}
            ></Box>
          </Box>
        </Stack>

        <Stack direction={{ xs: 'column-reverse', md: 'row' }}>
          <Stack justifyContent="end" alignItems="center" width={{ xs: '100%', md: '50%' }}>
            <Box>
              <Box
                p={{ xs: '16px 21px 24px 16px', md: '30px 30px 60px 30px' }}
                border={`1px solid ${theme.palette.secondary.main}`}
                boxShadow={`6px 8px 0px ${theme.palette.secondary.main}`}
                borderRadius="16px"
                bgcolor="#FFF"
                ml={0}
                mr="112px"
              >
                <Typography variant="h6">Design, select, and buy ease-of-use</Typography>
              </Box>

              <Box
                p={{ xs: '16px 21px 24px 16px', md: '30px 30px 60px 30px' }}
                border={`1px solid ${theme.palette.secondary.main}`}
                boxShadow={`6px 8px 0px ${theme.palette.secondary.main}`}
                borderRadius="16px"
                bgcolor="#FFF"
                mt={{ xs: '-10px', md: '-44px' }}
                ml="56px"
                mr="56px"
              >
                <Typography variant="h6">Complimentary design services</Typography>
              </Box>

              <Box
                p={{ xs: '16px 16px 24px 16px', md: '30px' }}
                border={`1px solid ${theme.palette.secondary.main}`}
                boxShadow={`6px 8px 0px ${theme.palette.secondary.main}`}
                borderRadius="16px"
                bgcolor="#FFF"
                mt={{ xs: '-10px', md: '-44px' }}
                ml="112px"
                mr={0}
              >
                <Typography variant="h6">Design alternatives, revisions, and selection consultation</Typography>
              </Box>
            </Box>
          </Stack>

          <Stack mb={{ xs: 6, md: 17 }} pl={{ xs: 0, md: 4.5 }} width={{ xs: '100%', md: '50%' }}>
            <Typography variant="h4" mb={3} width={{ xs: '100%', sm: '50%', md: '45%', lg: '40%' }}>
              Life Is Hard Swag Isn’t
            </Typography>

            <Typography variant="subtitle1">
              At <strong>SwagCharm</strong>, we don’t simply create <strong>Swag for your brand</strong>, we embody
              yours. Your passion, purpose, and mission are automatic. Effortless. Excellent. We believe your Swag
              design process should be the same.
              <br />
              Your custom, curated selection of high-quality Swag items is just a click away. You built your brand, your
              team, and your organization, now build the <strong>custom Swag Pack</strong> that propels your vision
              forward.
            </Typography>
          </Stack>
        </Stack>

        {/* Right circle */}
        <Box
          height={960}
          width={960}
          position="absolute"
          top={236}
          left="calc(100% - 233px)"
          borderRadius="50%"
          display={{ xs: 'none', lg: 'block' }}
          sx={{
            background: 'linear-gradient(180deg, #B7D8F3 0%, rgba(203, 255, 254, 0) 100%)',
          }}
        ></Box>

        {/* Left circle */}
        <Box
          height={600}
          width={510}
          position="absolute"
          top={139}
          right="calc(100% - 150px)"
          borderRadius="50%"
          display={{ xs: 'none', lg: 'block' }}
          sx={{
            background: 'linear-gradient(180deg, #B7D8F3 0%, rgba(203, 255, 254, 0) 100%)',
          }}
        ></Box>
      </Container>
    </Box>
  );
}
